export default class TooltipsterHtmlElement extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        $(this).tooltipster({
			contentAsHTML: true
		});
    }
}


window.customElements.define('tooltipster-html', TooltipsterHtmlElement);